var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pin-info-wrapper"},[_c('MoleculesProjectBuildingMoleculePinInfoContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }